import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Copy, HorizontalRule } from '@elparking/components'
import { LOCALE_TIME_FORMAT, CALENDAR_DATETIME_SHORT_FORMAT } from 'commons/js/constants'
import DateTime from 'commons/js/ui/DateTime'
import LoadingBlock from 'commons/js/ui/LoadingBlock'

const getPlaceName = (place) => {
    if (!place) return ''
    return place.name
}

const StepOneData = ({ rates }) => {
    const { originPOI, startDate, destinationPOI, endDate, timeZone } = rates
    return <Box width='100%'>
        <Flex width='100%'>
            <Box width='calc(50% - 10px)'>
                {startDate
                    ? <Copy padding='0' fontSize='xxSmall'>
                        <DateTime value={startDate} format={CALENDAR_DATETIME_SHORT_FORMAT} timeZone={timeZone} />{', '}
                        <DateTime value={startDate} format={LOCALE_TIME_FORMAT} timeZone={timeZone} />
                    </Copy>
                    : <Box mb='5px'><LoadingBlock color='gray40' size='large' width='80px' /></Box>
                }
                {originPOI
                    ? <Copy.truncate padding='0' fontWeight='regular' fontSize='xxSmall'>
                        {getPlaceName(originPOI)}
                    </Copy.truncate>
                    : <LoadingBlock color='gray40' size='large' width='50px' />
                }
            </Box>
            <Box width='20px' padding='0 4px'>
                <HorizontalRule background='gray30' height='100%' width='1px' margin='0' />
            </Box>
            <Box width='calc(50% - 10px)'>
                {startDate
                    ? <Copy padding='0' fontSize='xxSmall'>
                        <DateTime value={endDate} format={CALENDAR_DATETIME_SHORT_FORMAT} timeZone={timeZone}/>{', '}
                        <DateTime value={endDate} format={LOCALE_TIME_FORMAT} timeZone={timeZone} />
                    </Copy>
                    : <Box mb='5px'><LoadingBlock color='gray40' size='large' width='80px' /></Box>
                }
                {destinationPOI
                    ? <Copy.truncate padding='0' fontWeight='regular' fontSize='xxSmall'>
                        {getPlaceName(destinationPOI)}
                    </Copy.truncate>
                    : <LoadingBlock color='gray40' size='large' width='60px' />
                }
            </Box>
        </Flex>
    </Box>
}
StepOneData.propTypes = {
    rates: PropTypes.object,
}

export default StepOneData
